import React from 'react';
import './styles/App.scss';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';

function App() {
  const [page, setPage] = React.useState('Home');

  const renderPage = () => {
    switch (page) {
      case 'Home': return <Home setPage={setPage} />;
      case 'About': return <About setPage={setPage} />;
      case 'Projects': return <Projects />;
      case 'Contact': return <Contact />;
      default: return <Home setPage={setPage} />;
    }
  };

  return (
    <div className="App">
      <Navbar setPage={setPage} currentPage={page} />
      <main>
        {renderPage()}
      </main>
    </div>
  );
}

export default App;
